import React from 'react';

/**
 * Echo, LingoPing's bat mascot. Each mood has a job: hello (greeting, empty states), celebrate
 * (a finished review or deck), ping (words are due), thinking (a card is being created), learning
 * (loading a review), sleeping (nothing due), sad (something went wrong). The artwork lives in
 * public/brand/ and comes from Docs/brand/round3-echo/generate.py.
 */
export type EchoMood =
  | 'hello'
  | 'celebrate'
  | 'ping'
  | 'thinking'
  | 'learning'
  | 'sleeping'
  | 'sad'
  // For the tour of the dashboard: pointing at something, a wink, a bright idea.
  | 'point'
  | 'wink'
  | 'idea';

function brandUrl(file: string): string {
  const path = `brand/${file}`;
  return typeof chrome !== 'undefined' && chrome.runtime?.getURL
    ? chrome.runtime.getURL(path)
    : `/${path}`;
}

interface EchoProps {
  mood: EchoMood;
  size?: number;
  /** Leave empty when the picture is decoration next to text that already says the same thing. */
  alt?: string;
  style?: React.CSSProperties;
}

export const Echo: React.FC<EchoProps> = ({ mood, size = 96, alt = '', style }) => (
  <img
    src={brandUrl(`echo-${mood}.svg`)}
    alt={alt}
    aria-hidden={alt ? undefined : true}
    width={size}
    height={size}
    draggable={false}
    style={{ display: 'block', flexShrink: 0, ...style }}
  />
);

/** The app icon (Echo's head on an indigo tile), used as the logo in page headers. */
export const EchoLogo: React.FC<{ size?: number }> = ({ size = 32 }) => (
  <img
    src={brandUrl('echo-icon.svg')}
    alt=""
    aria-hidden
    width={size}
    height={size}
    draggable={false}
    style={{ display: 'block', flexShrink: 0, borderRadius: size * 0.23 }}
  />
);
